export const ChannelBehaviorActionType = {
  Say: 'Say',
  Dial: 'Dial',
  Conference: 'Conference',
  AIAgent: 'AIAgent'
}
